<template>
  <b-navbar class="main-menu">
    <b-navbar-brand href="#">
      <img class="logo" src="@/assets/logo.png">
      {{ $t('menu.appName') }}
    </b-navbar-brand>

    <b-navbar-nav class="ml-auto" v-if="!isAppEmbedded">
      <!--
      <b-nav-item v-if="hasUser">
        <router-link to="/edit">
          <icon name="user"></icon>
        </router-link>
      </b-nav-item>

      <b-nav-item v-if="hasUser">
        <router-link to="/blackboard">
          <icon name="info-circle"></icon>
        </router-link>
      </b-nav-item>
      -->

      <b-nav-item-dropdown :text="language">
        <b-dropdown-item
          v-for="lang in languages"
          value="lang"
          :active="lang===language"
          :key="lang"
          @click="setLanguage(lang)">
          {{lang}}
        </b-dropdown-item>
      </b-nav-item-dropdown>

      <b-nav-text>&nbsp;&nbsp;</b-nav-text>

      <b-nav-item v-if="hasUser">
        <router-link to="/logout">
          <icon name="sign-out"></icon>
        </router-link>
      </b-nav-item>
    </b-navbar-nav>

  </b-navbar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'MainMenu',
  data () {
    return {
      language: this.$store.state.ui.language
    }
  },
  computed: {
    ...mapState({
      languages: state => state.ui.languages,
      isAppEmbedded: state => state.ui.isAppEmbedded
    }),
    ...mapGetters(['hasUser'])
  },
  watch: {
    language (newLanguage) {
      this.$store.commit('setUILanguage', newLanguage)
    }
  },
  methods: {
    // @TD NOTE: using a method for setting the language is a workaround
    // actually we should bind the dropdown to the language property and
    // get it updated automatically
    setLanguage (language) {
      this.language = language
    }
  }
}
</script>

<style scoped>
.main-menu {
  background-color: rgba(255, 255, 255, 0.7);
}

.logo {
  height: 30pt;
}

.navbar-nav{
  flex-direction: row;
}

.nav-item {
  padding-left: 10pt;
}
</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue